import { createSelector } from '@reduxjs/toolkit';

import { selectVillagesLink } from '../../../selectors';
import { TSuburbanCatalog } from '../../../types/suburbanCatalog';
import { selectIsMoscowOrSpbRegions } from '../selectIsMoscowOrSpbRegions';
import { selectIsSuburbanListing } from '../selectIsSuburbanListing';

export const getSuburbanCatalogsTypes = createSelector(
  [selectIsSuburbanListing, selectVillagesLink, selectIsMoscowOrSpbRegions],
  (isSuburbanListing, villagesLink, showBuildersCatalog): TSuburbanCatalog[] => {
    const catalogs: TSuburbanCatalog[] = [];

    if (!isSuburbanListing) {
      return catalogs;
    }

    if (villagesLink) {
      catalogs.push('villages');
    }

    if (showBuildersCatalog) {
      catalogs.push('builders');
    }

    return catalogs;
  },
);
